import { Component, Injector, OnInit } from '@angular/core';
import { BaseComponent } from '../../base.component';
import { StoreService } from 'src/app/Services/store';
@Component({
	selector: 'click-listening',
	template: ` <div id="click_listening"></div> `,
})
export class ClickListeningComponent extends BaseComponent implements OnInit {
	mediaAlphaUrl?: string;
	MediaAlphaExchangeloadInterval: NodeJS.Timeout;
	constructor(injector: Injector, storeService: StoreService) {
		super(injector);

		let globalAttributes = storeService.getGlobalAttributes();
		if (globalAttributes) {
			this.mediaAlphaUrl = globalAttributes.mediaAlphaUrl;
		}

		const scriptEle = document.createElement('script');
		scriptEle.setAttribute('src', this.mediaAlphaUrl);
		document.head.appendChild(scriptEle);
		scriptEle.onload = this.onload.bind(this);
	}

	onload() {
		(<any>window).MediaAlphaExchange = {
			type: 'ad_unit',
			placement_id: this.control.attributes.placementId,
			version: '17',
			sub_1: this.control.attributes.friendlyId,
			data: {
				policy_type: this.control.attributes.lob,
				current_company: this.control.attributes.currentCompany,
				currently_insured: this.control.attributes.currentlyInsured,
				properties: [
					{
						property_type: this.control.attributes.propertyType,
						year_built: this.control.attributes.PLYearBuilt,
						square_footage: this.control.attributes.SquareFootage,
					},
				],
				zip: this.control.attributes.zipCode,
			},
		};

		this.MediaAlphaExchangeloadInterval = setInterval(() => {
			if (window['MediaAlphaExchange__load']) {
				(<any>window).MediaAlphaExchange__load('click_listening');
				clearInterval(this.MediaAlphaExchangeloadInterval);
			}
		}, 0);
	}
	ngOnInit() {}
}
